/** Display-only text matches. Never use these as extraction citations or truth. */
export function fieldDisplayMatches(lines: readonly { text: string }[], value: string): number[] {
  const normalize = (text: string) =>
    text.normalize('NFKC').replace(/\s+/gu, ' ').trim().toLocaleLowerCase();
  const wanted = normalize(value);
  if (!wanted) return [];
  const word = /[\p{L}\p{N}_]/u;
  let offset = 0;
  const spans = lines.map((line, index) => {
    const text = normalize(line.text);
    const span = { index, text, start: offset, end: offset + text.length };
    offset += text.length + 1;
    return span;
  });
  const text = spans.map((span) => span.text).join(' ');
  const matched = new Set<number>();
  let at = text.indexOf(wanted);
  while (at >= 0) {
    const before = text[at - 1],
      after = text[at + wanted.length];
    const numericFragment =
      (/\d/u.test(wanted[0]) && /[.,/-]/u.test(before ?? '') && /\d/u.test(text[at - 2] ?? '')) ||
      (/\d/u.test(wanted.at(-1)!) &&
        /[.,/-]/u.test(after ?? '') &&
        /\d/u.test(text[at + wanted.length + 1] ?? ''));
    if (
      !numericFragment &&
      (!before || !word.test(before) || !word.test(wanted[0])) &&
      (!after || !word.test(after) || !word.test(wanted.at(-1)!))
    ) {
      for (const span of spans)
        if (span.end > at && span.start < at + wanted.length) matched.add(span.index);
    }
    at = text.indexOf(wanted, at + 1);
  }
  return [...matched];
}
